import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TranscriptionsComponent } from '../../../transcriptions/transcriptions.component';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { conversationSlideInAndOutAnimation } from '../../configurations/conversation-animations.config';

@Component({
  selector: 'cv-conversation-mobile-view',
  standalone: true,
  imports: [SelectButtonModule, TranscriptionsComponent, RouterOutlet, FormsModule],
  templateUrl: './conversation-mobile-view.component.html',
  styleUrl: './conversation-mobile-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [conversationSlideInAndOutAnimation],
})
export class ConversationMobileViewComponent {
  readonly navOptions: TMobileNav[] = ['Transcript', 'Details'];
  selectedNavOption: TMobileNav = 'Transcript';
}

type TMobileNav = 'Transcript' | 'Details';
